import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IGenericJSON } from '../helpers/interface';
import { Observable, map } from 'rxjs';
import { School } from '../models/school';
import { User } from '../models/user';
import { District } from '../models/district';
import { Integration } from '../models/integration';

@Injectable({
  providedIn: 'root',
})
export class DistrictAdminService {
  private http: HttpClient = inject(HttpClient);
  base = '';

  getSchools() {
    return this.http
      .get<IGenericJSON[]>('api/schools')
      .pipe(map((data: any) => School.digestResponse(data)));
  }

  getDistricts() {
    return this.http
      .get<IGenericJSON[]>('api/schools/districts')
      .pipe(map((data: any) => District.digestResponse(data)));
  }

  getSchoolStaff(schoolId: string | number) {
    return this.http
      .get<IGenericJSON[]>(`api/schools/${schoolId}/staff`)
      .pipe(map((data: any) => User.digestResponse(data)));
  }

  addIntegration(form: FormData): Observable<any> {
    return this.http.post<any>(`/api/integration`, form);
  }

  getIntegration() {
    return this.http
      .get<IGenericJSON[]>(`api/integration`)
      .pipe(map((data: any) => Integration.digest(data)));
  }

  syncIntegration(trigger: 'manual' = 'manual') {
    return this.http
      .post<any>('/api/integration/sync', { trigger })
      .pipe(map((data: any) => Integration.digest(data)));
  }
}
